import { match, useStateTransition } from "@codesandbox/states";
import { useSession } from "hooks/api/useSession";

import { useAnalytics } from "hooks/useAnalytics";

import { BlockingLoader } from "./BlockingLoader";
import { EditorLayout } from "./Editor/EditorLayout";
import { GlobalError } from "./Error/GlobalError";

export const SessionMatcher: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [session] = useSession();
  const track = useAnalytics();

  useStateTransition(session, "UNAUTHENTICATED", () => {
    track("anon_user");
  });

  return (
    <>
      {match(session, {
        UNAUTHENTICATED: ({ error, transitionState }) => {
          if (error) {
            return (
              <GlobalError context={{ error }} errorCode="UNAUTHENTICATED" />
            );
          }

          if (transitionState?.state === "AUTHENTICATING") {
            return (
              <EditorLayout>
                <BlockingLoader>Authenticating...</BlockingLoader>
              </EditorLayout>
            );
          }

          return children;
        },
        AUTHENTICATED: ({ transitionState }) => {
          if (transitionState?.state === "SIGNING_OUT") {
            return (
              <EditorLayout>
                <BlockingLoader>Signing out...</BlockingLoader>
              </EditorLayout>
            );
          }
          return children;
        },
      })}
    </>
  );
};
